import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const webflow = defineConnector({
  identifier: "webflow",
  name: "Webflow",
  tagLine: "Visual website builder and CMS",
  logo,
  protocol: "http",
  tags: ["engineering", "productivity"],
  defaultUrlPattern: () => "https://api\\.webflow\\.com/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Create a Webflow App",
      items: [
        {
          kind: "markdown",
          content:
            "Visit the [Webflow Dashboard](https://webflow.com/dashboard/workspace/) and go to **Apps & integrations > Workspace apps** to create a new app.",
        },
      ],
    },
    {
      title: "Configure your app",
      items: [
        {
          kind: "markdown",
          content: "Copy and paste the following information into the form:",
        },
        {
          kind: "copyable",
          label: "Redirect URI",
          value: "{API_URL}/connected-apps/oauth/webflow/callback",
        },
      ],
    },
    {
      title: "Enter your client credentials",
      items: [
        {
          kind: "input",
          label: "Client ID",
          placeholder: "Paste your Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client Secret",
          placeholder: "Paste your Client Secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
    {
      title: "Define scopes for this connection",
      items: [
        {
          kind: "markdown",
          content:
            "Add [scopes](https://docs.developers.webflow.com/data/reference/scopes) in a space separated list below.",
        },
        {
          kind: "input",
          label: "Scopes",
          placeholder: "sites:read cms:read",
          required: true,
          defaultValue: "sites:read",
          helperText: "Space separated list of desired scopes.",
          target: { kind: "oauthConnection", field: "scopes" },
        },
      ],
    },
    {
      title: "Authorize your Webflow account",
      items: [
        {
          kind: "markdown",
          content:
            "Finally, authorize your Webflow account to complete the connection.",
        },
        {
          kind: "oauth",
          dependsOn: [
            { kind: "oauthConnection", field: "clientId" },
            { kind: "oauthConnection", field: "clientSecret" },
            { kind: "oauthConnection", field: "scopes" },
          ],
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "authorization_code",
    authorizationEndpoint: () => "https://webflow.com/oauth/authorize",
    tokenEndpoint: () => "https://api.webflow.com/oauth/access_token",
    tokenEndpointAuthMethod: () => "client_secret_post",
    clientCredentialsFrom: "db",
    scopes: () => [],
  },
  connectionTest: {
    protocol: "http",
    request: () => "https://api.webflow.com/v2/token/introspect",
  },
});
